// File: CostOfLiving.jsx

import { useState, useEffect } from "react"
import "./CostOfLiving.css"

const CostOfLiving = ({ countryData }) => {
  const { costOfLiving = {} } = countryData
  const {
    gaugePosition = 0,
    expances = [],
    breakdown = []
  } = costOfLiving

  const [needlePosition, setNeedlePosition] = useState(0)

  // Animate the needle to the gaugePosition from countryData
  useEffect(() => {
    const timer = setTimeout(() => {
      setNeedlePosition(Number(gaugePosition))
    }, 500)
    return () => clearTimeout(timer)
  }, [gaugePosition])

  return (
    <div className="cost-living-container">
      <h1>Post Admission Experience</h1>

      <div className="cost-of-living-section">
        <h2>Cost Of Living in {countryData.name}</h2>
        <div className="cost-gauge">
          <div className="gauge-container">
            <div className="gauge">
              <div className="gauge-fill"></div>
              <div
                className="gauge-needle"
                style={{ transform: `translateX(-50%) rotate(${needlePosition}deg)` }}
              ></div>
            </div>
            <div className="gauge-labels">
              <span className="low">Low</span>
              <span className="high">High</span>
            </div>
          </div>
        </div>
      </div>

      <div className="monthly-expenses-section">
        <h2>Monthly Living Expenses in {countryData.name}</h2>
        <div className="expenses-grid">
          {expances.map((expense, index) => (
            <div className="expense-card" key={index}>
              <div className={`expense-icon ${expense.category.toLowerCase()}-icon`}>
                {/* placeholder icon */}
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="10" stroke="#FF5A5F" strokeWidth="2" />
                </svg>
              </div>
              <h3>{expense.category}</h3>
              <p className="expense-range">{expense.range}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="living-costs-breakdown">
        <h2>Detailed Cost Breakdown</h2>
        <div className="cost-breakdown-grid">
          {breakdown.map((section, idx) => (
            <div className="cost-category" key={idx}>
              <h3>{section.category}</h3>
              <div className="cost-item">
                <span>{section.items.name}</span>
                <span>{section.items.cost}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* WhatsApp Button */}
      <a
        href="https://wa.me/1234567890"
        className="whatsapp-button"
        target="_blank"
        rel="noopener noreferrer"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
             viewBox="0 0 24 24" fill="white">
          <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946
                   .003-6.556 5.338-11.891 11.893-11.891 3.181.001
                   6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236
                   3.48 8.414-.003 6.557-5.338 11.892-11.893
                   11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305
                   1.654zm6.597-3.807c1.676.995 3.276 1.591
                   5.392 1.592 5.448 0 9.886-4.434 9.889-9.885
                   .002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887
                   4.434-9.889 9.884-.001 2.225.651 3.891
                   1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464
                   c-.074-.124-.272-.198-.57-.347-.297-.149-1.758
                   -.868-2.031-.967-.272-.099-.47-.149-.669.149
                   -.198.297-.768.967-.941 1.165-.173.198-.347.223
                   -.644.074-.297-.149-1.255-.462-2.39-1.475
                   -.883-.788-1.48-1.761-1.653-2.059-.173-.297
                   -.018-.458.13-.606.134-.133.297-.347.446
                   -.521.151-.172.2-.296.3-.495.099-.198.05
                   -.372-.025-.521-.075-.148-.669-1.611-.916
                   -2.206-.242-.579-.487-.501-.669-.51l-.57-.01
                   c-.198 0-.52.074-.792.372s-1.04 1.016-1.04
                   2.479 1.065 2.876 1.213 3.074c.149.198
                   2.095 3.2 5.076 4.487.709.306 1.263.489
                   1.694.626.712.226 1.36.194 1.872.118.571
                   -.085 1.758-.719 2.006-1.413.248-.695.248
                   -1.29.173-1.414z"/>
        </svg>
      </a>
    </div>
  )
}

export default CostOfLiving
